import { LabelData, LabelDataItem } from './types';

export const getVendor = (data: LabelData) => {
  const { Item, Order } = data;

  if (!Order) {
    return getVendorID(Item);
  }

  // if label(s) are printed from a PO - "Order" will be included in LabelData
  const { vendorID: orderVendorID, Vendor } = Order;

  // if the PO does not have a vendor - vendorID in Order (LabelDataOrder) will be 0, and "Vendor" will not be included (default to the logic used for individual items)
  if (orderVendorID === '0' && !Vendor) {
    return getVendorID(Item);
  }

  if (Vendor) {
    const { name, vendorID } = Vendor;
    const { ItemVendorNums } = Item;
    const { ItemVendorNum } = ItemVendorNums || {};

    if (Array.isArray(ItemVendorNum)) {
      const vendorValue = ItemVendorNum.find((itemVendor) => itemVendor.vendorID === vendorID);
      if (vendorValue) return vendorValue.value;
    } else if (ItemVendorNum?.value && ItemVendorNum.vendorID === vendorID) {
      return ItemVendorNum.value;
    }

    return name;
  }

  return undefined;
};

export const getVendorID = (Item: LabelDataItem) => {
  const { Vendor, ItemVendorNums } = Item;

  // Item has single (default) vendor (not printed from a PO) - print vendor name
  if (Vendor && !ItemVendorNums) {
    const { name } = Vendor;
    return name;
  }

  // Item has multiple vendors (not printed from a PO) - print value (ItemVendorNums) associated with defaultVendorID
  if (Vendor && ItemVendorNums) {
    const { defaultVendorID } = Item;
    const { ItemVendorNum } = ItemVendorNums;

    const defaultVendorValue = [ItemVendorNum]
      .flat()
      .find((vendor) => vendor.vendorID === defaultVendorID)?.value;

    return defaultVendorValue;
  }

  return undefined;
};
